// SelectField.tsx
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';
import { cn } from '@/core/lib/utils';

interface SelectFieldProps {
    label?: string;
    value?: string | number | null;
    onValueChange: (value: string) => void; // underlying Select gives string
    options: { value: string | number; label: string | React.ReactNode }[];
    placeholder?: string;
    disabled?: boolean;
    error?: string;
    defaultValue?: string | number | null;
    className?: string;
    labelClassName?:string;
    inputClassName?: string;
    iconClassName?: string;
    errorMessageClassName?: string;
    renderSelected?: (option: { value: string | number; label: string | React.ReactNode }) => React.ReactNode;
}

export default function SelectField({
    label,
    value,
    onValueChange,
    options,
    placeholder = '',
    disabled,
    error,
    defaultValue,
    className,
   labelClassName,
    inputClassName,
    iconClassName,
    errorMessageClassName,
    renderSelected // Custom renderer for the selected option in the trigger; useful for showing shorthand or partial labels.
}: SelectFieldProps) {
    // convert incoming value (string|number|null) to the string Select expects,
    // or undefined so the Select shows its placeholder.
    const selectValue =
        value === null || value === undefined || value === ''
            ? undefined
            : String(value);

    const selectDefault =
        defaultValue === null || defaultValue === undefined || defaultValue === ''
            ? undefined
            : String(defaultValue);

    const selectedOption = options.find(
        o => String(o.value) === selectValue
    );


    return (
        <div className={cn('flex flex-col gap-2', className)}>
            {label && <label className={labelClassName || 'text-primary-600 font-bold'}>{label}</label>}
            <Select
                value={selectValue}
                onValueChange={onValueChange} // will be a string
                disabled={disabled}
                defaultValue={selectDefault}
            >
                <SelectTrigger
                    className={cn(
                        'w-full justify-between h-10 overflow-hidden',
                        error && 'border-red-500',
                        inputClassName
                    )}
                    iconClassName={iconClassName}
                >
                    {selectedOption && renderSelected ? (
                        renderSelected(selectedOption)
                    ) : (
                        <SelectValue placeholder={placeholder} />
                    )}
                    {/* <SelectValue placeholder={placeholder} /> */}
                </SelectTrigger>
                <SelectContent>
                    {options.map(option => (
                        <SelectItem key={String(option.value)} value={String(option.value)}>
                            {option.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
            {error && <p className={cn('text-sm text-red-500', errorMessageClassName)}>{error}</p>}
        </div>
    );
}
